import type {Canvas} from '@postermywall/fabricjs-2';

/**
 * This is used instead of standard compare because that returns true only if they refer to the exact same object
 * @param {Object} canvas
 * @param {string} cursor
 * @returns {boolean}
 */
export const setCanvasCursor = (canvas: Canvas, cursor: string): void => {
  canvas.defaultCursor = cursor;
  canvas.hoverCursor = cursor;
  canvas.moveCursor = cursor;
};
